import React from 'react';
import { 
    Card, 
    CardHeader,
    CardBody,
    CardFooter
} from '../../../../../../../../../common/Kendo/Card';
import { MisReportDescription } from './MisReportDescription';
import { MisReportToolbar } from './MisReportToolbar';
import { MisBlankPdfDownloadButton } from './MisBlankPdfDownloadButton';
import PageMessage from '../../../../../../../../../common/PageMessage/pageMessageComponent';

/**
 * MisReportHeaderCard component renders the header card for the Management Information Systems report.
 * It includes a title, description, and a toolbar for selecting DOT and year.
 * @param {Object} props - Component properties.
 * @param {Array} props.dotList - List of DOT options.
 * @param {Object} props.selectedDOT - Currently selected DOT option.
 * @param {Function} props.setSelectedDOT - Function to set the selected DOT.
 * @param {Object} props.selectedYear - Currently selected year option.
 * @param {Function} props.setSelectedYear - Function to set the selected year.
 * @param {Array} props.testingAuthorityOptions - List of testing authority options.
 * @param {Object} props.selectedTestingAuthority - Currently selected testing authority option.
 * @param {Function} props.setSelectedTestingAuthority - Function to set the selected testing authority.
 * @param {Function} props.setMisReportData - Function to set the MIS report data.
 * @param {object} props.selectedSite - Selected site object.
 * @return {JSX.Element} The rendered MisReportHeaderCard component.
 */
export const MisReportHeaderCard = ({
  dotList,
  selectedDOT,
  setSelectedDOT,
  selectedYear,
  setSelectedYear,
  testingAuthorityOptions,
  selectedTestingAuthority,
  setSelectedTestingAuthority,
  setMisReportData,
  selectedSite
}) => (
  <Card className="mb-4">
    <CardHeader className="card-header d-flex justify-content-between align-items-center">
      <span>Management Information Systems</span>
      <MisBlankPdfDownloadButton />
    </CardHeader>
    <CardBody>
      <MisReportDescription />
    </CardBody>
    <CardFooter>
      {selectedSite ? (
        <MisReportToolbar
          dotList={dotList}
          selectedDOT={selectedDOT}
          setSelectedDOT={setSelectedDOT}
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          testingAuthorityOptions={testingAuthorityOptions}
          selectedTestingAuthority={selectedTestingAuthority}
          setSelectedTestingAuthority={setSelectedTestingAuthority}
          onSubmit={setMisReportData}
        />
      ) : (
        <PageMessage bgColor='warning' className='mb-2 rounded'>
          <i className="fas fa-map-marker-alt mr-2" />
          Please select a location to generate the report.
        </PageMessage>
      )}
    </CardFooter>
  </Card>
);